import { Inject, Component } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    template: `
    <div style="padding: 24px; position: relative;">
        <h2 style="font-size: 18px !important; margin-bottom: 8px; margin-top: 40px;">{{'generic_back_action_title' | translate}}</h2>
        <p>{{'generic_back_action_label' | translate}}</p>
        <div style="margin-top: 24px; display: flow-root;">
            <button class="delete-btn flat" mat-button style="float: right; background-color: #D4050F; color: white;"
                    (click)="respond(data)">
                {{'generic_confirm' | translate}}
            </button>
            <button mat-button class="flat" style="float: right; margin-right: 8px;"
                    (click)="discard()">{{'generic_cancel' | translate}}</button>
        </div>
        <button mat-icon-button style="position: absolute; top: 10px; right: 10px;" (click)="discard()">
            <mat-icon style="color: #9E9E9E;">close</mat-icon>
        </button>
    </div>
    `,
})
export class BackModalComponent {

    constructor(
        public dialogRef: MatDialogRef<BackModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    respond(data) {
        this.dialogRef.close(data);
    }

    discard(): void {
        this.dialogRef.close();
    }

}
